import { createStyles } from 'antd-style'

export const useStyles = createStyles(
  ({ token }, props: { isRead?: boolean }) => ({
    wrapper: {
      borderRadius: 12,
      border: `1px solid ${token.colorBorder}`,
      minWidth: 330,
      maxWidth: 400
    },
    popover: {
      '.ant-popover-inner': {
        padding: 0,
        borderRadius: 12
      }
    },
    header: {
      padding: '12px 8px',
      borderBottom: `1px solid ${token.colorBorder}`
    },
    readAll: {
      color: token.colorPrimary,
      cursor: 'pointer'
    },
    notification: {
      borderBottom: `1px solid ${token.colorBorder}`,
      backgroundColor: props?.isRead
        ? token.colorWhite
        : `${token.primary.primary3}1a`,
      padding: 16,
      cursor: 'pointer'
    },
    dot: {
      width: 10,
      height: 10,
      borderRadius: '50%',
      backgroundColor: token.primary.primary2
    },
    count: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '100%',
      height: 24,
      borderRadius: 12,
      border: `1px solid ${token.colorWhite}`,
      padding: '0px 6px',
      background: token.colorError,
      color: token.colorWhite,
      fontWeight: 500,
      fontSize: 12,
      position: 'absolute',
      top: '-50%',
      right: '-50%',
      transform: 'translate(-10%, 30%)'
    },
    button: {
      width: 32,
      height: 32
    },
    emptyNotifications: {
      paddingBlock: 20
    },
    viewDetails: {
      padding: 0,
      margin: 0,
      width: 'fit-content'
    }
  })
)
